import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Header from "@/src/components/Header/Header";
import Sidebar from "@/src/components/Sidebar/Sidebar";
import { useSelector } from "react-redux";
import { RootState } from "./store";
import Preloyder from "./components/Preloyder/Preloyder";

const Layout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isPreloyder } = useSelector((state: RootState) => state.Preloyder);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Проверка авторизации
  // const savedUser = localStorage.getItem("userAuthInfo");
  // const parsedUser = savedUser ? JSON.parse(savedUser) : "WHO?";
  // const accessToken = parsedUser?.access_token;
  const accessToken = localStorage.getItem("accessToken") ? localStorage.getItem("accessToken") : "";
  const userLogin = localStorage.getItem("userLogin") ? localStorage.getItem("userLogin") : "";

  console.log(localStorage);

  useEffect(() => {
    if (!accessToken && location.pathname !== "/login") {
      navigate("/login", { replace: true });
    }
    if (accessToken && location.pathname === "/login") {
      navigate("/", { replace: true });
    }
  }, [accessToken, location.pathname, navigate]);

  // Если страница логина, не рендерим лэйаут
  if (location.pathname === "/login") {
    return <Outlet />;
  }

  return (
    <>
      {isPreloyder && <Preloyder />}
      <Sidebar />
      <section className="main">
        <Header username={userLogin} />
        <Outlet />
      </section>
    </>
  );
};

export default Layout;
